// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__Ed1aT","paramInput":"JobSimulator_paramInput__2UWqb","input":"JobSimulator_input__1mfT_"};